import {Component, Injector} from "@angular/core";
import {
    AbstractSelectSearchControlComponent
} from "../../framework/entity/search/search-controls/select-search-controls/abstract-select-search-control.component";
import {registerSearchControl} from "../../framework/entity/search/search-controls/abstract-search-control.component";

@Component({
    selector: "wbo-month-of-year-multi-select-search-control",
    templateUrl: "../../framework/entity/search/search-controls/select-search-controls/multi-select-search-control.component.html",
    providers: [
        registerSearchControl(MonthOfYearMultiSelectSearchControlComponent)
    ]
})
export class MonthOfYearMultiSelectSearchControlComponent extends AbstractSelectSearchControlComponent<any> {
    constructor(injector: Injector) {
        super(undefined, injector);

        this.buildData([
            {label: "wbo.common.month.january", value: "1"},
            {label: "wbo.common.month.february", value: "2"},
            {label: "wbo.common.month.march", value: "3"},
            {label: "wbo.common.month.april", value: "4"},
            {label: "wbo.common.month.may", value: "5"},
            {label: "wbo.common.month.june", value: "6"},
            {label: "wbo.common.month.july", value: "7"},
            {label: "wbo.common.month.august", value: "8"},
            {label: "wbo.common.month.september", value: "9"},
            {label: "wbo.common.month.october", value: "10"},
            {label: "wbo.common.month.november", value: "11"},
            {label: "wbo.common.month.december", value: "12"}
        ]);
    }
}
